import { JSX } from "react";
import { Navigate, Outlet } from "react-router-dom";

export const PrivateGuard = (): JSX.Element => {
    const isAuthenticated = (): boolean => {
        try {
            const token = false /* localStorage.getItem("token"); */
            return token;
        } catch (error) {
            console.error("Error accessing localStorage:", error);
            return false;
        }
    };

    return isAuthenticated() ? <Outlet /> : <Navigate to="/login" replace />;
};